<layout-default>
    <div header>
        <div toolbar>
            <h4>
                <i-feather name="database"></i-feather> {{'Couriers for region' | translate}}
            </h4>
        </div>

        <div toolbar>
            <button id="partner-courier-btn-create" class="btn btn-sm btn-uppercase btn-white" (click)="createCourier()">
                <i-feather [style.height.px]="23" [style.width.px]="13" class="mg-r-10" name="plus"></i-feather> {{ 'Add courier' | translate }}
            </button>
            <div id="partner-courier-btn-search" class="filter-container">
                <div class="phrase-filter">
                    <input type='text' class="list-filter form-control" placeholder="{{'type to search' | translate}}" (keyup)='applyFiltering($event)'/>
                </div>
            </div>
        </div>
        <hr />
    </div>
    
    <div content>
        <div *ngIf="(list$ | async) as list">
            <ngx-datatable 
                id="partner-courier-table" 
                class="bootstrap" 
                [rows]="partnerCouriers" 
                [columns]="columns" 
                [columnMode]="'flex'"
                [headerHeight]="50" 
                [footerHeight]="50" 
                [messages]="tableMessages" 
                [rowHeight]="'auto'" 
                [externalPaging]="true"
                [count]="list.totalElements"
                [offset]="queryParams.page"
                [rowClass]="rowClass"
                [limit]="queryParams.size"
                [scrollbarH]="scrollBarHorizontal"
                (sort)="onSort($event)"
                (page)="setPage($event)">
                <ng-container *ngFor="let col of columns">
                    <ngx-datatable-column [flexGrow]="col.flexGrow" [prop]="col.prop">
                        <ng-template let-column="column" ngx-datatable-header-template class="header" let-sort="sortFn">
                            <b (click)="sort()">{{ col.name | translate }}</b>
                        </ng-template>
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <div id="partner-table-col-{{col.prop}}" *ngIf="isColumnToTranslate(col.prop)">{{ value | translate }}</div>
                            <div id="partner-table-col-{{col.prop}}" *ngIf="!isOptionsColumn(col.prop) && !isColumnToTranslate(col.prop) && !isColumnActive(col.prop)">{{ value }}</div>

                            <div id="partner-table-col-{{col.prop}}" *ngIf="isColumnActive(col.prop)">
                                <div class="custom-control custom-checkbox w-50 text-center">
                                    <input [checked]="value" type="checkbox" class="custom-control-input" id="active" disabled>
                                    <label class="custom-control-label justify-content-start" for="active">&nbsp;</label>
                                </div>
                            </div>

                            <div *ngIf="isOptionsColumn(col.prop)">
                                <div class="dropdown" dropdown>
                                    <button
                                        class="btn btn-outline-secondary btn-xs dropdown-toggle"
                                        type="button"
                                        id="dropdownMenuButton">
                                        {{ 'Select' | translate }}
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-right div-main-actions">
                                        <a 
                                            id="partner-courier-btn-edit"
                                            class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                            (click)="goToDetails(row.id)">
                                                {{'Edit' | translate }}
                                        </a>

                                        <a 
                                            id="partner-courier-btn-remove"
                                            class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                            (click)="remove(row.id)">
                                                {{'Remove' | translate }}
                                        </a>

                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ng-container>
            </ngx-datatable>
        </div>

        <div *ngIf="loader" class="load-spinner text-center">
            <i class="fa fa-spinner fast-pulse" aria-hidden="true"></i> {{ 'Please, wait!' | translate }}
        </div>

    </div>

</layout-default>

<ng-template #confirmation>
    <div class="modal-header">
        <h4 class="modal-title">{{'Confirm action' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="decline()"><span aria-hidden="true">&times;</span></button>
    </div>

    <div class="modal-body text-center">
        <p>{{'Do you confirm removal of the courier' | translate }}?</p>
        <button type="button" class="btn btn-brand-01" (click)="confirm()">
            {{'Yes, remove' | translate }}
        </button>
        <button type="button" class="btn btn-default" (click)="decline()">{{'Cancel' | translate }}</button>
    </div>
</ng-template>
